const FILL_IN_THE_BLANKS_TYPES = new Set([
  "Reading & Writing: Fill in the Blanks",
  "Reading: Fill in the Blanks",
]);

const QUESTION_LEVEL_TYPES = new Set([
  "Multiple Choice, Multiple Answers",
  "Multiple Choice, Single Answer",
  "Re-order Paragraphs",
]);

const normalizeSubCategory = (value) => String(value || "").replace(/\s+/g, " ").trim();

export const isPteReadingExplanationSupported = (subCategory) =>
  FILL_IN_THE_BLANKS_TYPES.has(normalizeSubCategory(subCategory)) ||
  QUESTION_LEVEL_TYPES.has(normalizeSubCategory(subCategory));

export const getPteReadingExplanationTargets = ({
  subCategory,
  correctAnswers = [],
  submissionResult = null,
} = {}) => {
  const normalizedSubCategory = normalizeSubCategory(subCategory);

  if (FILL_IN_THE_BLANKS_TYPES.has(normalizedSubCategory)) {
    const answerCount = Array.isArray(correctAnswers) && correctAnswers.length > 0
      ? correctAnswers.length
      : 1;

    return Array.from({ length: answerCount }).map((_, index) => ({
      type: "blank",
      key: `blank:${index}`,
      label: `Explain blank ${index + 1}`,
    }));
  }

  if (QUESTION_LEVEL_TYPES.has(normalizedSubCategory)) {
    return [{ type: "question", key: "question", label: "Explain answer" }];
  }

  return [];
};

const toPositiveNumber = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const buildPteReadingExplanationPayload = ({
  explanationContext,
  testData,
  target,
}) => {
  const userResponse = testData?.UserResponse || {};
  const mockTestAttemptedId = toPositiveNumber(explanationContext?.mockTestAttemptedId);
  const questionId = toPositiveNumber(
    userResponse.QuestionId ||
      userResponse.question_id ||
      userResponse.QuestionID ||
      testData?.QuestionId ||
      testData?.question_id
  );

  if (!mockTestAttemptedId || !questionId || !target?.type || !target?.key) {
    if (!mockTestAttemptedId && questionId && target?.type && target?.key) {
      const directPayload = {
        source: "practice",
        question_id: questionId,
        subcategory: userResponse.SubCategory,
        target_type: target.type,
        target_key: target.key,
        question_name: userResponse.QuestionName,
        question_statement: userResponse.QuestionStatement,
        option_names: userResponse.OptionNames,
        correct_answers: userResponse.correctAnswers || userResponse.AnswerNames,
        submission_result: userResponse.submissionResult,
      };

      Object.keys(directPayload).forEach((key) => {
        if (directPayload[key] == null) delete directPayload[key];
      });

      return directPayload;
    }

    return null;
  }

  const payload = {
    mock_test_attempted_id: mockTestAttemptedId,
    question_id: questionId,
    subcategory: userResponse.SubCategory,
    target_type: target.type,
    target_key: target.key,
  };

  const studentUserId = toPositiveNumber(explanationContext?.studentUserId);
  if (studentUserId) payload.student_user_id = studentUserId;

  return payload;
};
